import { Button as ChakraButton } from '@chakra-ui/react';
import React from 'react';

type ButtonProps = React.ComponentPropsWithRef<typeof ChakraButton> & {
  'data-testid'?: string;
};

const Button = React.forwardRef<any, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraButton ref={ref} {...props}>
        {children}
      </ChakraButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
